export const catEstatusProceso = Object.freeze({
    NoAplica: 0,
    PRE_RESERVA: 1,
    RESERVA: 2,
    VUELOS: 3,
    LIQUIDADO: 4,
    CANCELADO_CLIENTE: 5,
    CANECLADO_AGENTE: 6,
    BAJA_INACTIVIDAD: 7,
    FINALIZADO: 8,
    CAMBIO_VIAJE: 9
})